import { render } from "./productionReport.vue?vue&type=template&id=fb4ba21e&scoped=true"
import script from "./productionReport.vue?vue&type=script&lang=js"
export * from "./productionReport.vue?vue&type=script&lang=js"

import "./productionReport.vue?vue&type=style&index=0&id=fb4ba21e&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb4ba21e"]])

export default __exports__